import { HttpServer } from '@/services/server'
import { EventType as  reportServerEventType } from './reportServer'

interface EventType {
  id: number
  model: string
  scene: 'start_learning' | 'pay' | 'home'
  action: 'explosure' | 'click'
  inviter_id: number
  index: number
}

export const UbtElement = 'rec_list_x'
export const ExposureSPM = `wk.opu2-home.${UbtElement}`

declare const window: any

export const WrapReport = (eventSingle: EventType[]) => {
    try {
      const len = eventSingle.length
      const resultArray = []
      for (let i = 0; i < len; i++) {
         resultArray.push({
            ubt: ExposureSPM,
            evt: reportServerEventType.impress,
            evt_params: {
              ch_id: eventSingle[i].id,
              model: eventSingle[i].model,
              inviter_id: eventSingle[i].inviter_id,
              index: eventSingle[i].index
            }
         })
      }
      HttpServer.reportServerAPI(resultArray)

    } catch (err) {console.log(err)}

    setSPM(`wk.hp001a.home.d00a`)
}

export const hotSpotServer = {
  async hotSpotLogs(data: EventType[]) {
    try {
      WrapReport(data)
    } catch (error) {console.log(error)}
  }
}

export function setSPM(spm: string) {
    if ( window.TorDataService) {
      window.TorDataService.spm = spm
    }
}



// WEBPACK FOOTER //
// ./src/services/Modules/hotSpotServer.ts